export default {
  namespaced: true,
  state: {
    bannerCorrectStatus: false,
    bannerIncorrectStatus: false,
    bannerQuestionStatus: true,
    currentExercise: 0,
    currentLives: 3,
    eggAnimationStatus: false,
    explanationMessageStatus: false,
    exerciseCompleted: false,
    exercisePrevent: false,
    gameCompleted: false, // default false
    homeScreenStatus: true,
    maxLives: 3,
    muteStatus: false,
    playerScore: 0,
    settingsStatus: false,
    speechStatus: true,
  },
  getters: {
    bannerCorrectStatus: state => state.bannerCorrectStatus,
    bannerIncorrectStatus: state => state.bannerIncorrectStatus,
    bannerQuestionStatus: state => state.bannerQuestionStatus,
    currentExercise: state => state.currentExercise,
    currentLives: state => state.currentLives,
    eggAnimationStatus: state => state.eggAnimationStatus,
    explanationMessageStatus: state => state.explanationMessageStatus,
    exerciseCompleted: state => state.exerciseCompleted,
    exercisePrevent: state => state.exercisePrevent,
    gameCompleted: state => state.gameCompleted,
    homeScreenStatus: state => state.homeScreenStatus,
    maxLives: state => state.maxLives,
    muteStatus: state => state.muteStatus,
    playerScore: state => state.playerScore,
    settingsStatus: state => state.settingsStatus,
    speechStatus: state => state.speechStatus,
  },
  mutations: {
    homeStartClick(state) {
      state.homeScreenStatus = false;
    },
    decrement(state) {
      state.currentLives -= 1;
    },
    increment(state) {
      state.currentExercise += 1;
    },
    addAnswerPoints(state) {
      state.playerScore += 300;
    },
    resetGame(state) {
      state.bannerCorrectStatus = false;
      state.bannerIncorrectStatus = false;
      state.bannerQuestionStatus = true;
      state.currentExercise = 0;
      state.currentLives = 3;
      state.eggAnimationStatus = false;
      state.explanationMessageStatus = false;
      state.exerciseCompleted = false;
      state.exercisePrevent = false;
      state.gameCompleted = false;
      state.homeScreenStatus = true;
      state.maxLives = 3;
      state.playerScore = 0;
    },
  },
  actions: {
    homeStartClick({ commit }) {
      commit('homeStartClick');
    },
    increment({ commit }) {
      commit('increment');
    },
    decrement({ commit }) {
      commit('decrement');
    },
    addAnswerPoints({ commit }) {
      commit('addAnswerPoints');
    },
    resetGame({ commit }) {
      commit('resetGame');
    },
  },
};
